"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Select = {
    parts: ['field'],
    baseStyle: {
        field: {
            backgroundColor: 'white',
        },
    },
};
exports.default = Select;
